import { render, staticRenderFns } from "./AppCalendarHeader.vue?vue&type=template&id=4e7094a1&scoped=true&lang=pug&"
import script from "./AppCalendarHeader.vue?vue&type=script&lang=js&"
export * from "./AppCalendarHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppCalendarHeader.vue?vue&type=style&index=0&id=4e7094a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7094a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7094a1')) {
      api.createRecord('4e7094a1', component.options)
    } else {
      api.reload('4e7094a1', component.options)
    }
    module.hot.accept("./AppCalendarHeader.vue?vue&type=template&id=4e7094a1&scoped=true&lang=pug&", function () {
      api.rerender('4e7094a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/AppCalendarHeader.vue"
export default component.exports